module.exports = __webpack_public_path__ + "img/icons_all_sports-wh-13.37e6bc00.png";